import { ReactNode } from 'react';

import { SessionManager } from '@/components/auth/SessionManager';
import { StepUpProvider } from '@/components/auth/StepUpProvider';
import { AdminLayout } from './AdminLayout';

interface AdminRouteShellProps {
  children: ReactNode;
}

export function AdminRouteShell({ children }: AdminRouteShellProps) {
  return (
    <SessionManager timeoutMinutes={15} warningMinutes={2}>
      <StepUpProvider adminScope><AdminLayout>{children}</AdminLayout></StepUpProvider>
    </SessionManager>
  );
}
